<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="pageConfig.title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onRefresh()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <app-base-outbox-messages-detail [model]="model">
    </app-base-outbox-messages-detail>

    <!-- show phonebook receivers -->
    <div
      class="row tw-justify-center tw-mt-3"
      *ngIf="isShowSmartSmsRecipient && model?.smartSmsRecipients.length > 0"
    >
      <div class="tw-w-full">
        <h5
          class="tw-mr-2 tw-my-4 tw-text-primary-700 dark:tw-text-primary-200"
        >
          {{ "common.chosenSmartSmsDetail" | translate }}
        </h5>
        <app-dynamic-table
          [config]="pageConfig?.tableConfig"
          [loading]="pageConfig.loading"
          [isEmpty]="pageConfig?.isEmpty"
          [hasError]="pageConfig?.hasError"
          (sortObject)="getSortItems($event)"
          (comparisonObjects)="getComparisonObjects($event)"
          (pageNumber)="changePageNumber($event)"
          (pageSize)="changePageSize($event)"
        >
          <ng-container
            table-body
            *ngIf="model?.smartSmsRecipients && !pageConfig.loading"
          >
            <ng-container
              *ngFor="let item of model?.smartSmsRecipients; let i = index"
            >
              <tr>
                <!-- index -->
                <td class="tw-text-center !tw-p-4">
                  {{ paginationModel?.firstIndex + i }}
                </td>

                <!-- title -->
                <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
                  <td-value class="fw-700" [value]="item?.title"></td-value>
                </td>

                <!-- persianPrice -->
                <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
                  <td-value
                    class="tw-font-bold"
                    type="number"
                    [value]="item?.persianPrice | numberSeparator"
                  ></td-value>
                </td>

                <!-- englishPrice -->
                <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
                  <td-value
                    class="tw-font-bold"
                    type="number"
                    [value]="item?.englishPrice | numberSeparator"
                  ></td-value>
                </td>

                <!-- fromIndex -->
                <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
                  <td-value
                    class="tw-font-bold text-dark"
                    type="number"
                    [value]="item?.fromIndex"
                  ></td-value>
                </td>

                <!-- count -->
                <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
                  <td-value
                    class="tw-font-bold text-dark"
                    type="number"
                    [value]="item?.count | numberSeparator"
                  ></td-value>
                </td>

                <!-- startDateTime -->
                <td class="tw-py-2">
                  <td-value
                    type="dateTime"
                    [value]="item?.startDateTime"
                  ></td-value>
                </td>

                <!--endDateTime-->
                <td class="tw-py-2">
                  <td-value
                    type="dateTime"
                    [value]="item?.endDateTime"
                  ></td-value>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </app-dynamic-table>
      </div>
    </div>
  </div>
</app-page-body>
